export const KEAP_ADDONS_GROUP_NAME = 'Keap Add-Ons'
export const COMBINED_ADDONS_TAB_ID = '__thryv-addons'
export const COMBINED_ADDONS_TAB_NAME = 'Thryv Add-Ons'

// One tab per add-on group by default. With `combineNonKeap`, every group
// except Keap Add-Ons is folded into a single "Thryv Add-Ons" tab (placed where
// the first folded group was). A tab only groups the *display*: each tab keeps
// its original `groups`, because plan swapping (groupPlanCodes) is per group.
export function buildAddonTabs(groups, combineNonKeap) {
  if (!combineNonKeap) {
    return groups.map(group => ({
      id: group.id,
      name: group.name,
      groups: [group],
    }))
  }

  const isKeap = group =>
    group.name?.trim().toLowerCase() === KEAP_ADDONS_GROUP_NAME.toLowerCase()
  const others = groups.filter(group => !isKeap(group))
  const tabs = []
  let combinedAdded = false

  groups.forEach(group => {
    if (isKeap(group)) {
      tabs.push({id: group.id, name: group.name, groups: [group]})
    } else if (!combinedAdded) {
      combinedAdded = true
      tabs.push({
        id: COMBINED_ADDONS_TAB_ID,
        name: COMBINED_ADDONS_TAB_NAME,
        groups: others,
      })
    }
  })

  return tabs
}
